import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";
import Cross_Icon from "@assets/svg/match/missing.svg";
import Check_Icon from "@assets/svg/match/attending.svg";
import Plus from '@assets/svg/plus.svg';

export const Wrapper = styled.div`
    width:100%;
    padding-bottom: 40px;
    margin-top: -20px;
    position: relative;
    overflow: unset;


    .center{
        text-align: center;
    }

    .right{
        text-align: right;
    }

    .clickable{
        cursor: pointer;
        
        &:hover{
            opacity: 0.8;
        }
    }

    .p-right{
        padding-right:2rem;
    }

    .imgWidth{
        width:36px;
        padding:5px 5px;
    }
`;

export const Space = styled.div`
    content: ' ';
    height:20px;
`;


export const FilterBox = styled.div`
    width:100%;
    display:flex;
    align-items: center;
    gap:1.5rem;
    z-index: 1;
    position: relative;
`;

export const ExportDropDown = styled.div`
    margin-left: auto;
    border: 1px solid #AAAAAA;
    border-radius: 5px;
    display:flex;
    font-size: 14px;
    color:#AAAAAA;
    position: relative;
    

    > span {
        display:flex;
        
    gap:1rem;
        align-items: center;
        cursor: pointer;
        height:24px;
        padding:3px 12px;

        > svg{
            height:80%;
            path{
                fill:#AAAAAA;
            }
        }
    }
`;

export const ExportContent = styled.div<{open?:boolean}>`
    display:${props => props.open?"flex":"none"};
    position: absolute;
    top:34px;
    right:0;
    border-radius: 5px;
    flex-direction: column;
    font-size: 14px;
    background:#fff;
    box-shadow: 0 0 4px rgba(0,0,0,0.25);
    padding:5px 0;
    min-width: 100%;

    svg{
        width:16px;
        path{
            fill:#414141;
        }
    }

    > span{
        display:flex;
        align-items: center;
        gap:6px;
        color:#414141;
        padding:4px 12px;
        font-size: 16px;
        transition: all 0.1s ease-in-out;
        cursor: pointer;
        white-space: nowrap;

        :hover{
            background:#e4e4e4;
        }
    }
`;

export const FilterInput = styled.div<{ width: string }>`
    position: relative;
   input {
   border-radius: 5px;
   height:26px;
   outline:none;
   border: 1px solid #d8d8d8;
   padding: 0 12px;
   width:${props => props.width};
   max-width: 100%;
   font-size: 14px;
   }
`;

export const FilterRange = styled.input`
   -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 16rem;
    outline: none;

    :focus {
    outline: none;
    }

    ::-webkit-slider-runnable-track {
    background-color: #2a848eb5;
    border-radius: 0.2rem;
    height: 0.4rem;
    }

::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  margin-top: -7px; /* Centers thumb on the track */
  background-color: #b5b5b5;
  border-radius: 3.5rem;
  height: 1.5rem;
  width: 1.5rem;
}


::-moz-range-track {
  background-color: #2a848eb5;
  border-radius: 0.2rem;
  height: 0.4rem;
}

::-moz-range-thumb {
  background-color: #b5b5b5;
  border: none; /*Removes extra border that FF applies*/
  border-radius: 3.5rem;
  height: 1.5rem;
  width: 1.5rem;
}
:focus::-moz-range-thumb{
  outline: 3px solid #b5b5b5;
  outline-offset: 0.125rem;
}
`;

export const FilterButton = styled.div`
   background:#2a848e21;
   border-radius: 30px;
   position: relative;
   display:flex;
   align-items: center;
   gap:0.5rem;
   padding:3px 12px;
`;


export const FilterReset = styled(Cross_Icon, {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display' && prop !== 'absolute',
}) <{ display?: boolean, absolute?:boolean }>`
    display: ${props => props.display ? "block" : "none"};
    height:10px;
    cursor: pointer;    
    position: ${props => props.absolute?"absolute":"unset"};
    top: ${props => props.absolute?"10px":"unset"};
    right: ${props => props.absolute?"10px":"unset"};  
    path{
        fill:#888888;
    }
`;

export const FilterText = styled.div`
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap:4px;
`;

export const FilterDrop = styled.div<{ show?: boolean, big?:boolean }>`
   display: ${props => props.show ? "block" : "none"};
   position: absolute;
   top:34px;
   left:0;
   border-radius: 3px;
   padding:1rem;
   box-shadow: 0 0 3px rgba(0,0,0,0.25);
   background:#fff;
   width: max-content;
   min-width: ${props => props.big ? "450px" : "100%"};

   span{
    padding: 4px 0;
    font-size: 14px;
    font-weight: 400;
    display: block;
   }

   hr{
        height:1px;
        background: #eeeeee;
        border:none;
   }
`;

export const FilterDropHead = styled.h3`
    font-size: 20px;
    font-weight: 500;
    padding: 0 40px 10px 6px ;
    display:flex;
`;

export const FilterInfo = styled.div`
    position: absolute;
    top:18px;
    right:16px;
    font-weight: 500;
    height:18px; 
    width:18px;
    border-radius: 50%;

    div{
        width:100%;
        height:100%;
    }
    svg{
        height:100%;
        path{
            fill:#acacac;
        }
    }
`;

export const FilterDropInput = styled.input<{ width: string }>`
   border-radius: 3px;
   height:24px;
   outline:none;
   border: 1px solid #d8d8d8;
   padding: 0 12px;
   width:${props => props.width};
   max-width: 100%;
   font-size: 12px;
   margin-bottom: 8px;

    &[type=number]{
        -moz-appearance: textfield;
    }

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const FilterButtons = styled.div`
   display:inline-flex;
   gap:0.5rem;
   padding:12px 4px 4px 4px;

   button{
    border:1px solid #acacac;
    border-radius: 3px;
    font-size: 14px;
    min-width:90px;
    padding:2px 12px;
    transition: all 0.05s ease-in-out;

    :hover{
        background:#2a848e;
        border:1px solid #2a848e;
        color:#fff;
    }
   }
`;

export const FilterItem = styled.div<{ rowStack?: boolean, border?:boolean}>`
   display:flex;
   flex-direction: ${props => props.rowStack ? "row" : "column"};
   gap: ${props => props.rowStack ? "8px" : "0"};
   padding: ${props => props.border?"6px 4px 6px 4px":"4px"};
   justify-content: start;
   border-bottom: ${props => props.border?"1px solid #eeeeee":"unset"};
   flex-wrap: wrap;
   max-width: 450px;
   h4{
    font-size: 16px;
    font-weight: 500;
   }


`;

export const DateContainer = styled.div<{multiActive?:boolean}>`
   display:flex;
   margin-bottom: 8px;
   flex-direction: column;

   > span  {
    width:auto !important;
   }
`;

export const GapScroll = styled.div`
   display:flex;
   flex-direction: column;
   gap: 8px;
   max-height: 214px;
   overflow: auto;

   scrollbar-width: thin;
   scroll-margin-left:4px;
   

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: darkgrey;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    > div {
        cursor:pointer;
    }
`;

export const CheckBox = styled.div<{ checked?: boolean, borderLess?: boolean }>`
    margin: ${props => props.borderLess ? " 0 auto" : "0"};
    width:18px;
    height:18px;
    border:1px solid ${props => props.borderLess ? "transparent" : "#888888"};
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${props => props.borderLess ? "unset" : "pointer"};
    background: ${props => props.checked ? "#2a848e" : "transparent"};

    svg{
        display: ${props => props.checked ? "block" : "none"};
        height:66%;
        path{
            fill:#fff;
        }
    }
`;

export const CheckboxIcon = styled(Check_Icon)`
    
`;

export const CheckboxIconCross = styled(Cross_Icon)`
    
`;

export const Cross = styled(Plus)`
  transform: rotate(45deg);
  transform-origin: center;

  path {
    fill: #acacac;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 42px;
  top: 5px;
  width: 16px;
  height: 16px;
`;

export const QuickBtn = styled.button<{active?:boolean}>`
  border:1px solid ${props => props.active?'#2a848e':'#f0f0f0'};
  background:${props => props.active?'#2a848e':'#f0f0f0'};
  color: ${props => props.active?'#fff':'unset'};
  border-radius: 3px;
  font-size: 14px;
  min-width:90px;
  padding:4px 12px;
  transition: all 0.05s ease-in-out;

  :hover{
      background:#2a848e;
      border:1px solid #2a848e;
      color:#fff;
  }
`;

export const FilterContainer = styled.div`
    max-height: 420px;
    overflow-y: auto;
`;